var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18737 5.26654C9.18737 8.18245 9.18737 12.7332 9.18737 12.7332M5.45404 8.99987H12.9207M9.18737 16.4665C5.06364 16.4665 1.7207 13.1236 1.7207 8.99987C1.7207 4.87614 5.06364 1.5332 9.18737 1.5332C13.3111 1.5332 16.654 4.87614 16.654 8.99987C16.654 13.1236 13.3111 16.4665 9.18737 16.4665Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.a027254dc3db0db24d272f529d9f5a9a.svg";
export { ForwardRef as ReactComponent };